import GeneratePayroll from "./pages/GeneratePayroll";
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";

import Dashboard from "./components/Dashboard";
import Login from "./Login";
import TemporaryInvoice from "./components/TemporaryInvoice";
import CBREInvoice from "./components/CBREInvoice";
import IILInvoice from "./components/IILInvoice";
import PettyCashPortal from "./pages/PettyCashPortal";
import FinanceAIEmployee from "./pages/FinanceAIEmployee";
import IILAttendanceAutomation from "./pages/IILAttendanceAutomation";
import ManagementFinance from "./pages/ManagementFinance";
import ClientTaxProfileAdmin from "./pages/ClientTaxProfileAdmin";
import AccountsReceivable from "./pages/AccountsReceivable";
import WhtGstControl from "./pages/WhtGstControl";
import ManualInvoiceEntry from "./pages/ManualInvoiceEntry";
import OperatingExpenses from "./pages/OperatingExpenses";
import MonthlyPnl from "./pages/MonthlyPnl";
import CreateInvoiceHub from "./pages/CreateInvoiceHub";
import CortevaInvoice from "./pages/CortevaInvoice";
import CortevaReconciliation from "./pages/CortevaReconciliation";
import GSolarPPE from "./pages/GSolarPPE";
import PayrollFinancing from "./pages/PayrollFinancing";
import FixedFeeStatement from "./pages/FixedFeeStatement";
import IILAdvances from "./pages/IILAdvances";
import SharedStatement from "./pages/SharedStatement";
import { PPE_VIEWER_EMAILS } from "./services/gsolarPpeService";

// External client login — sees the PPE tab and nothing else.
const PPE_ONLY_EMAILS = ["krashid@gsolar.pk"];

function App() {

  const [user, setUser] = useState(null);
  const [authReady, setAuthReady] = useState(false);
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    return onAuthStateChanged(auth, (u) => {
      setUser(u);
      setAuthReady(true);
    });
  }, []);

  useEffect(() => {
    const updatePath = () => setPath(window.location.pathname);
    window.addEventListener("popstate", updatePath);
    return () => window.removeEventListener("popstate", updatePath);
  }, []);

  // Public, login-free statement link: /share/<client>/<token>
  if (path.startsWith("/share/")) {
    return <SharedStatement token={path.split("/")[3] || ""} />;
  }

  if (!authReady) {
    return (
      <div className="login-page">
        <div className="login-hero">
          <div>
            <img src="/alm-logo.png" alt="ALM logo" className="brand-logo" />
            <h1>ALM Invoice Engine</h1>
            <p>Preparing your workspace...</p>
          </div>
        </div>
        <div className="login-panel-wrap">
          <div className="login-panel">
            <h2 style={{ marginTop: 0 }}>Loading</h2>
            <p className="page-copy">Checking your saved session.</p>
          </div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Login onLogin={() => window.location.reload()} />;
  }

const signedInEmail = user.email?.toLowerCase() || "";
if (PPE_ONLY_EMAILS.includes(signedInEmail) || (path === "/gsolar-ppe" && PPE_VIEWER_EMAILS.includes(signedInEmail))) {
  return <GSolarPPE />;
}

if (path === "/temporary-invoice") {
  return <TemporaryInvoice />;
}

if (path === "/create-invoice") {
  return <CreateInvoiceHub />;
}

if (path === "/corteva-invoice") {
  return <CortevaInvoice />;
}

if (path === "/corteva-reconciliation") {
  return <CortevaReconciliation />;
}

if (path === "/general-invoice") {
  return <Dashboard />;
}

if (path === "/cbre-invoice") {
  return <CBREInvoice />;
}

if (path === "/iil-invoice") {
  return <IILInvoice />;
}

if (path === "/iil-attendance") {
  return <IILAttendanceAutomation />;
}

if (path === "/iil-advances") {
  return <IILAdvances />;
}

if (path === "/generate-payroll") {
  return <GeneratePayroll />;
}

if (path === "/petty-cash") {
  return <PettyCashPortal />;
}

if (path === "/finance-ai" && user.email?.toLowerCase() === "nazim@almhr.com") {
  return <FinanceAIEmployee />;
}

if (path === "/management-finance" && ["admin@almhr.com", "nazim@almhr.com"].includes(user.email?.toLowerCase())) {
  return <ManagementFinance />;
}

if (path === "/management-finance/tax-profiles" && ["admin@almhr.com", "nazim@almhr.com"].includes(user.email?.toLowerCase())) {
  return <ClientTaxProfileAdmin />;
}

if (path === "/management-finance/receivables" && ["admin@almhr.com", "nazim@almhr.com"].includes(user.email?.toLowerCase())) {
  return <AccountsReceivable />;
}

if (path === "/management-finance/wht-gst-control" && ["admin@almhr.com", "nazim@almhr.com"].includes(user.email?.toLowerCase())) {
  return <WhtGstControl />;
}

if (path === "/management-finance/manual-entry" && ["admin@almhr.com", "nazim@almhr.com"].includes(user.email?.toLowerCase())) {
  return <ManualInvoiceEntry />;
}

if (path === "/management-finance/operating-expenses" && ["admin@almhr.com", "nazim@almhr.com"].includes(user.email?.toLowerCase())) {
  return <OperatingExpenses />;
}

if (path === "/management-finance/fixed-fee" && ["admin@almhr.com", "nazim@almhr.com"].includes(user.email?.toLowerCase())) {
  return <FixedFeeStatement />;
}

if (path === "/management-finance/payroll-financing" && ["admin@almhr.com", "nazim@almhr.com"].includes(user.email?.toLowerCase())) {
  return <PayrollFinancing />;
}

if (path === "/management-finance/monthly-pnl" && ["admin@almhr.com", "nazim@almhr.com"].includes(user.email?.toLowerCase())) {
  return <MonthlyPnl />;
}

return <CreateInvoiceHub />;
}

export default App;
